import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { SuperAdministrateur } from 'src/app/shared/models/superadmin';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-add-superadmin',
  standalone: false,
  templateUrl: './add-superadmin.component.html',
  styleUrl: './add-superadmin.component.scss'
})
export class AddSuperadminComponent {

  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,

  ) { }

  item: SuperAdministrateur = new SuperAdministrateur();

  departementItems: any = [];
  communeItems: any = [];
  arrondissementItems: any = [];
  cooperativeItems: any = [];

  ngOnInit() {
    this.item.user_reference = this.localStorage.getUsers().data.reference;
    console.log("this.item.user_reference", this.item.user_reference);

    this.getPays();
  }
  addSuperAdministrateur() {

    if (!this.item.canSave()) {

      this.messageService.add({ severity: 'info', summary: "AFRICEREAL", detail: this.item.getErrorMessage() });

    }
    else if (this.item.canSave()) {

      this.ngxService.start();
      this.authService.addSuperAdministrateur(this.item).subscribe(
        (response: any) => {
          //console.log("la reponse du webservice",response);
          this.messageService.add({ severity: 'success', summary: "AFRICEREAL", detail: response.message });

          this.fecthDataService.notifySeriviceCreated();
          this.modalService.dismissAll();

          this.ngxService.stop();

        },
        (error : any) => {
          console.log("le message d'erreur", error);
          // Accès au message spécifique pour l'email
          console.log("Erreur email :", error.status);
          this.messageService.add({ severity: 'error', summary: "AFRICEREAL", detail: 'L\'adresse mail ou numéro de téléphone déjà utilisée' });
          this.ngxService.stop();

        }
      )
    }


  }
  getPays() {
    this.paramService.getPays().subscribe(

      (response: any) => {
        this.departementItems = response.data;
        console.log("this.departementItems", this.departementItems);
      },
      (error) => {
        console.log("une erreur est survenu", error);

      }

    );
  }

  getvilleByPays(departementId: number) {
    this.paramService.getVilleById(departementId).subscribe(
      (response: any) => {
        this.communeItems = response.data;
        console.log("Liste des communes pour le département", departementId, ":", this.communeItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des communes :", error);
      }
    );
  }
  getArrondissementByCommune(communeId: number) {
    this.paramService.getVilleById(communeId).subscribe(
      (response: any) => {
        this.arrondissementItems = response.data;
        console.log("Liste des arrondissements pour la commune", communeId, ":", this.arrondissementItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des arrondissements :", error);
      }
    );
  }




  close() {

    this.modalService.dismissAll();
  }


}
